import React, {useEffect, useState} from 'react';

import "./workXLarge.css"
import "./work.css" 
import "./workMedium.css"
import "./workSmall.css"
import "../../components/project/projectSmall.css";
import "../../components/project/project.css";

import { Project, PopupCatalog, PopupProject } from '../../components';
import { projectData } from './workData';
import { Swiper,SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper";

const Work = () => {

  const [Scroll, setScroll] = useState(true)
window.addEventListener('scroll', () => {
    if (window.scrollY > 250) {
        setScroll(false)
    } else if (window.scrollY <= 600) {
        setScroll(true)
    }
}); 

//SPLIT THE DATA CATEGORY FOR THE PROJECT COMPONENT 
const fullstack = projectData?.fullstack;
const frontend = projectData?.frontend;
const component = projectData?.component;

//CREATE POPUP SHOWING PROJECTS BY CATEGORY
const [fullstackCategoryPopup, setFullstackCategoryPopup] = useState(false);
const [frontendCategoryPopup, setFrontendCategoryPopup] = useState(false);
const [componentCategoryPopup, setComponentCategoryPopup] = useState(false);

//CREATE POPUP OF THE SELECTED PROJECT
const [fullstackPopupProject, setFullstackPopupProject] = useState(false);
const [frontendPopupProject, setFrontendPopupProject] = useState(false);
const [componentPopupProject, setComponentPopupProject] = useState(false);

//DEFINE THE INDEX OF THE SELECTED PROJECT ON SWIPER
const [componentSwiperActiveIndex, setComponentSwiperActiveIndex] = useState(0);
const [frontendSwiperActiveIndex, setFrontendSwiperActiveIndex] = useState(0);
const [fullstackSwiperActiveIndex, setFullstackSwiperActiveIndex] = useState(0);

//DEFINE THE INDEX OF THE SELECTED PROJECT ON CATALOG
const [componentCatalogActiveIndex, setComponentCatalogActiveIndex] = useState(0);
const [frontendCatalogActiveIndex, setFrontendCatalogActiveIndex] = useState(0);
const [fullstackCatalogActiveIndex, setFullstackCatalogActiveIndex] = useState(1);


useEffect(() => {
  if(fullstackCategoryPopup === true){
    setFullstackActiveIndex(fullstackCatalogActiveIndex);
  } else {
    setFullstackActiveIndex(fullstackSwiperActiveIndex);
  };
  if(frontendCategoryPopup === true){
    setFrontendActiveIndex(frontendCatalogActiveIndex);
  } else {
    setFrontendActiveIndex(frontendSwiperActiveIndex);
  };
  if(componentCategoryPopup === true){
    setComponentActiveIndex(componentCatalogActiveIndex);
  } else {
    setComponentActiveIndex(componentSwiperActiveIndex);
  }
}, [fullstackSwiperActiveIndex, fullstackCatalogActiveIndex, fullstackCategoryPopup, 
    componentSwiperActiveIndex, componentCatalogActiveIndex, componentCategoryPopup,
    frontendSwiperActiveIndex, frontendCatalogActiveIndex, frontendCategoryPopup,])


function catalogFullstackOnClick(index) {
  setFullstackCatalogActiveIndex(index);
  setFullstackPopupProject(true);
}
function catalogFrontendOnClick(index) {
  setFrontendCatalogActiveIndex(index);
  setFrontendPopupProject(true);
}
function catalogComponentOnClick(index) {
  setComponentCatalogActiveIndex(index);
  setComponentPopupProject(true);
}

//DEFINE THE INDEX OF THE SELECTED PROJECT
const [componentActiveIndex, setComponentActiveIndex] = useState(0);
const [frontendActiveIndex, setFrontendActiveIndex] = useState(0);
const [fullstackActiveIndex, setFullstackActiveIndex] = useState(0);

// NO SCROLL WHEN POPUP APPEARS
useEffect(() => {
  if (fullstackPopupProject === true|| fullstackCategoryPopup === true|| frontendPopupProject === true||   frontendCategoryPopup === true||componentPopupProject === true|| componentCategoryPopup === true){
      document.getElementById('html').style.overflowY = 'hidden';
      document.getElementById('html').style.width = '104vw';
  } else {
    document.getElementById('html').style.overflowY = 'scroll';
    document.getElementById('html').style.width = '100vw';
  }
})


  return (
    <section id='work-wrapper' className={`${Scroll ? 'work-wrapper' : "darkBackground work-wrapper"}`} >
      <div className='intro' id='work'>
        <div className='intro-left'>
          <h2>
            PROJECTS
          </h2>
        </div>
        <div className='intro-right'>
          <p>
          {/* My projects are detail oriented, each of them teach me new skills and push me towards a greater level. */}
          Find my select works that challenged me, taught me new techniques and developed my coding skills.
          </p>
        </div>
      </div>

{/* FULLSTACK SWIPER *//* FULLSTACK SWIPER *//* FULLSTACK SWIPER *//* FULLSTACK SWIPER *//* FULLSTACK SWIPER *//* FULLSTACK SWIPER */}
      <div className='fullstack from-left slide-in'>
        <div className='main-swiper'>
                <Swiper
                  slidesPerView={1}
                  spaceBetween={30}
                  loop={false}
                  pagination={{clickable: true,}}
                  navigation={true}
                  modules={[Pagination, Navigation]}
                  className="mySwiper"
                  onRealIndexChange={(element)=>setFullstackSwiperActiveIndex(element.activeIndex)}
              >
                { fullstack?.map((item, index) => {
                      return (
                <div className='col-3 mb-3 slider-wrap' key={`'wrapper '${index}`} >
                  <SwiperSlide key={`'slide '${index}`}>
                    
                      <Project 
                        item = {item}
                        key={`'project'${index}`}
                        className='swiper'
                        onClick={() => setFullstackPopupProject(true)} 
                      />
                  </SwiperSlide>
                </div> 
                )})}
              </Swiper>
        </div>


        <div className='swiper-title'>
          <h3 className='firstTitle'>Fullstack</h3>
          <h3 className='firstSubtitle'>Projects</h3>
          <button onClick={() => setFullstackCategoryPopup(true)} className='main-button btn'>View all</button>
          <PopupCatalog 
            trigger={fullstackCategoryPopup} 
            setTrigger={setFullstackCategoryPopup}
            category={fullstack}
            title='Fullstack Projects'
            onClick={catalogFullstackOnClick} 
          >
          </PopupCatalog>
          <PopupProject 
            popupProject={fullstackPopupProject} 
            setPopupProject={setFullstackPopupProject} 
            category = {fullstack[fullstackActiveIndex]}
          />
        </div>
      </div>




{/* FRONTEND SWIPER *//* FRONTEND SWIPER *//* FRONTEND SWIPER *//* FRONTEND SWIPER *//* FRONTEND SWIPER *//* FRONTEND SWIPER */}
      <div className='frontend from-right slide-in'>
        <div className='swiper-title'>
          <h3 className='secondTitle'>Frontend</h3>
          <h3 className='secondSubtitle'>Projects</h3>
          <button onClick={() => setFrontendCategoryPopup(true)} className='main-button btn'>View all</button>
          <PopupCatalog 
            trigger={frontendCategoryPopup} 
            setTrigger={setFrontendCategoryPopup}
            category={frontend}
            title='Frontend Projects'
            onClick={catalogFrontendOnClick} 
          >
          </PopupCatalog>
          <PopupProject 
            popupProject={frontendPopupProject} 
            setPopupProject={setFrontendPopupProject} 
            category = {frontend[frontendActiveIndex]}
          />
        </div>


        <div className='main-swiper'>
              <Swiper
                  slidesPerView={1}
                  spaceBetween={30}
                  loop={false}
                  pagination={{clickable: true,}}
                  navigation={true}
                  modules={[Pagination, Navigation]}
                  className="mySwiper"
                  onRealIndexChange={(element)=>setFrontendSwiperActiveIndex(element.activeIndex)}
              >
                { frontend?.map((item, index) => {
                      return (
                <div className='col-3 mb-3 slider-wrap' key={`'wrapper '${index}`} >
                  <SwiperSlide key={`'slide '${index}`}>
                    
                      <Project 
                        item = {item}
                        key={`'project'${index}`}
                        className='swiper'
                        onClick={() => setFrontendPopupProject(true)} 
                      />
                  </SwiperSlide>
                </div> 
                )})}
              </Swiper>
        </div>
      </div>



{/* COMPONENT SWIPER *//* COMPONENT SWIPER *//* COMPONENT SWIPER *//* COMPONENT SWIPER *//* COMPONENT SWIPER */}
      <div className='component from-left slide-in'>
        <div className='main-swiper'>
              <Swiper
                  slidesPerView={1}
                  spaceBetween={30}
                  loop={false}
                  pagination={{clickable: true,}}
                  navigation={true}
                  modules={[Pagination, Navigation]}
                  className="mySwiper"
                  onRealIndexChange={(element)=>setComponentSwiperActiveIndex(element.activeIndex)}
              >
                { component?.map((item, index) => {
                      return (
                <div className='col-3 mb-3 slider-wrap' key={`'wrapper '${index}`} >
                  <SwiperSlide key={`'slide '${index}`}>
                    
                      <Project 
                        item = {item}
                        key={`'project'${index}`}
                        className='swiper'
                        onClick={() => setComponentPopupProject(true)} 
                      />
                  </SwiperSlide>
                </div> 
                )})}
              </Swiper>
        </div>



        <div className='swiper-title'>
          <h3 className='thirdTitle'>Tool Box</h3>
          {/* <h3 className='thirdSubtitle'></h3> */}
          <button onClick={() => setComponentCategoryPopup(true)} className='main-button btn'>View all</button>
          <PopupCatalog 
            trigger={componentCategoryPopup} 
            setTrigger={setComponentCategoryPopup}
            category={component}
            title='Tool box'
            onClick={catalogComponentOnClick}
          >
          </PopupCatalog>
          <PopupProject 
            popupProject={componentPopupProject} 
            setPopupProject={setComponentPopupProject}
            category = {component[componentActiveIndex]}
          />
        </div>
      </div>

      <div className='shape1'>
            <div className='circle1'>
                
            </div>
        </div>
    </section>
  )
}

export default Work